import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

const RepairAndReplacementDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout } = useAuth();
    const [selectedSalesMan, setSelectedSalesMan] = useState('');
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedCardType, setSelectedCardType] = useState('');
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
    }, []);

    useEffect(() => {
        fetchData('RepairAndReplacementApi', `/${id}`, token)
            .then(response => {
                if (response.responseCode === '1111') {
                    setFormData({ ...response.response_data.RepairAndReplacement, UpdatedBy: userId });
                    setInvoicedeatils(response.response_data.RepairAndReplacementDetails);
                    setSelectedSalesMan(response.response_data.RepairAndReplacement.SalesManId);
                    setSelectedCardType(response.response_data.RepairAndReplacement.CardType);
                }
            })
            .catch(err => console.error('Error fetching record:', err));
    }, [id]);

    const fetchDropdownSalesManOptions = () => {
        fetchData('RepairAndReplacementApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownSalesManOptions(data))
            .catch(err => console.error('Error fetching SalesMan:', err));
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('RepairAndReplacementApi', `/CardType/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownCardTypeOptions(data))
            .catch(err => console.error('Error fetching CardType:', err));
    };

    const fmt = (val) => (val ? parseFloat(val).toFixed(2) : '0.00');

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    return (
        <Fragment>
            <div className="pg-container">

                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Repair / Replacement Receipt — Details</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <Link to="/RepairAndReplacementIndex" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="pg-watermark">
                    <CopyrightIcon /><b>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">

                    {/* ── Row 1: Customer / Address / Phone / Receipt Date / Receipt No ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Customer Name <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Customer" value={formData.CustomerName || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                            <span className="pg-hcell-label">Address</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Address" value={formData.CustomerAddress || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Phone No <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Phone Number" value={formData.ContactNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Receipt Date <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.BillDate)} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Receipt No <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.BillNumber || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Invoice detail table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 10 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>Item Description</th>
                                    <th>Item Category</th>
                                    <th>Item Details</th>
                                    <th>Remarks</th>
                                    <th className="right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0 ? (
                                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: 12, color: '#94a3b8' }}>No items found.</td></tr>
                                ) : (
                                    invoicedeatils.map((invdetail, index) => (
                                        <tr key={index}>
                                            <td>{invdetail.ReceiptTypeName}</td>
                                            <td>{invdetail.ItemCategoryName}</td>
                                            <td>{invdetail.ItemName}</td>
                                            <td>{invdetail.Remarks}</td>
                                            <td className="right">{invdetail.Amount}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* ── Totals panel ── */}
                    <div className="pg-totals-panel" style={{ marginTop: 10 }}>
                        {/* Left: Remarks + summary */}
                        <div className="pg-totals-left">
                            <div className="pg-totals-remarks">
                                <span className="pg-tsum-label">Remarks</span>
                                <input className="pg-remarks-textarea" type="text" placeholder="Remarks"
                                    value={formData.Remarks || ''} readOnly />
                            </div>
                            <div className="pg-totals-summary">
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Sales Man</span>
                                    <select className="pg-tpay-select" value={selectedSalesMan} disabled style={{ width: 220 }}>
                                        <option value="">Select</option>
                                        {dropdownSalesManOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                                    </select>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Total</span>
                                    <span className="pg-tsum-value">{fmt(formData.TotalAmount)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Right: Grand Total + Payments */}
                        <div className="pg-totals-right">
                            {/* GST breakdown */}
                            <div className="pg-gst-breakdown">
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Taxable Amount</span>
                                    <span className="pg-tsum-value">{fmt(formData.TaxableAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">GST Rate</span>
                                    <span className="pg-tsum-value">{formData.GSTRate || 0}%</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">CGST ({(formData.GSTRate || 0) / 2}%)</span>
                                    <span className="pg-tsum-value">{fmt(formData.CGSTAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">SGST ({(formData.GSTRate || 0) / 2}%)</span>
                                    <span className="pg-tsum-value">{fmt(formData.SGSTAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Round Off</span>
                                    <span className="pg-tsum-value">{fmt(formData.RoundOff)}</span>
                                </div>
                            </div>

                            <div className="pg-grand-total-bar">
                                <span className="pg-gt-label">Total Amount</span>
                                <span className="pg-gt-value">{fmt(formData.TotalAmount)}</span>
                            </div>

                            <div className="pg-totals-pay-row">
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">Cash <span className="req">*</span></span>
                                    <input className={`pg-tpay-input${formData.CashAmount < 0 ? ' cash-negative' : ''}`}
                                        type="text" value={fmt(formData.CashAmount)} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">Card <span className="req">*</span></span>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt(formData.CardAmount)} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">UPI / RTGS / Other <span className="req">*</span></span>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt(formData.UPIAmount)} readOnly />
                                </div>
                            </div>

                            {(formData.CardAmount > 0 || formData.UPIAmount > 0) && (
                                <div className="pg-tpay-extra-row">
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Card Name <span className="req">*</span></span>
                                            <select className="pg-tpay-select" value={selectedCardType} disabled>
                                                <option value="">Select Card Type</option>
                                                {dropdownCardTypeOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                                            </select>
                                        </div>
                                    )}
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Card Number <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.CardNumber || ''} readOnly />
                                        </div>
                                    )}
                                    {formData.UPIAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">UPI / RTGS / Other No. <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.UPINumber || ''} readOnly />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>{/* end pg-card */}

            </div>
        </Fragment>
    );
};

export default RepairAndReplacementDetails;
